import { User as UserI, UserData } from '../../../index.d'

export class User implements UserI {
  id: number
  email: string
  firstName: string
  middleName: string
  lastName: string
  phone: string
  parent: boolean
  fakeUser: boolean
  isCustomer: boolean
  emailConfirmed: boolean
  fakeEmail: boolean
  phoneConfirmed: boolean
  createdAt: string
  recentRegistration: boolean
  profileEnriched: boolean
  skype: string
  graduate: boolean
  type: 'pupil' | 'agent'
  avatarUrl: string
  bonusAmount: number
  grade: { id: number; index: number | null }
  gradeChecked: boolean
  tags: string[]
  hasChats: boolean
  hasReferrals: boolean
  onboardingFinished: boolean
  externshipUser: boolean

  constructor(data: UserData) {
    if (typeof data !== 'object') throw new Error('data is wrong')

    this.id = data.id
    this.gradeChecked = data.gradeChecked
    this.email = data.email || ''
    this.firstName = data.firstName
    this.middleName = data.middleName || ''
    this.lastName = data.lastName
    this.phone = data.phone || ''
    this.parent = data.parent
    this.fakeUser = data.fakeUser
    this.isCustomer = data.isCustomer
    this.emailConfirmed = data.emailConfirmed
    this.fakeEmail = data.fakeEmail
    this.phoneConfirmed = data.phoneConfirmed
    this.createdAt = data.createdAt || ''
    this.recentRegistration = data.recentRegistration
    this.profileEnriched = data.profileEnriched
    this.skype = data.skype || ''
    this.graduate = data.graduate
    this.type = data.type
    this.avatarUrl = data.avatarUrl || ''
    this.bonusAmount = data.bonusAmount
    this.grade = data.grade
    this.tags = data.tags
    this.hasChats = data.hasChats
    this.hasReferrals = data.hasReferrals
    this.onboardingFinished = data.onboardingFinished
    this.externshipUser = data.externshipUser
  }

  isLoggedIn(): boolean {
    return this.id > 0 ? true : false
  }
}

export const DEFAULT_USER: UserData = {
  id: 0,
  gradeChecked: false,
  email: '',
  firstName: '',
  middleName: '',
  lastName: '',
  phone: '',
  parent: false,
  fakeUser: false,
  isCustomer: false,
  emailConfirmed: false,
  fakeEmail: false,
  phoneConfirmed: false,
  createdAt: '',
  recentRegistration: false,
  profileEnriched: false,
  skype: '',
  graduate: false,
  type: 'pupil',
  avatarUrl: '',
  bonusAmount: 0,
  grade: { id: 0, index: 0 },
  tags: [],
  hasChats: false,
  hasReferrals: false,
  onboardingFinished: false,
  externshipUser: false,
}
